import { Component, Input } from '@angular/core'
import { LogEvent } from 'src/app/interfaces/log'
import { GeneralService } from 'src/app/services/general/general.service'
import { LogService } from 'src/app/services/log/log.service'

@Component({
  selector: 'header-drawer-button',
  template: `
    <div class="button" click [elementName]="'menu'" (throttledClick)="this.toggleDrawer()">
      <i class="fas fa-bars" [ngStyle]="{ color: this.color }"></i>
    </div>
  `,
  styles: [
    `
      .button {
        margin-left: auto;
        width: 2.5rem;
        height: 2.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      i {
        color: var(--white);
        font-size: 1.5rem;
        font-weight: 400;
        line-height: 125%;
        letter-spacing: -0.48px;
      }
    `,
  ],
})
export class HeaderDrawerButtonComponent {
  constructor(private generalService: GeneralService, private logService: LogService) {}

  @Input() color?: string

  toggleDrawer(): void {
    this.logService.eventLogging(LogEvent.HEADER_DRAWER_CLICKED, { from: location.pathname })
    this.generalService.openDrawer()
  }
}
